import { isDefaultRovoChat } from '@atlassian/conversation-assistant-utils/default-agent';

import { areAgentIdListsEqual } from './agent-id-list-equality';
import { type SelectedAgentTransitionState } from './selected-agent-transition-state';

type ShouldHydrateDraftMentionIdsArgs = {
	state: SelectedAgentTransitionState;
	draftAgentIds: readonly string[];
	selectedAgentIds: readonly string[];
};

const shouldHydrateDraftMentionIds = ({
	state,
	draftAgentIds,
	selectedAgentIds,
}: ShouldHydrateDraftMentionIdsArgs): boolean => {
	if (state.isSubmitClearing) {
		return false;
	}
	if (
		areAgentIdListsEqual(state.lastHydratedDraftAgentIdsByPromptKey[state.promptKey], draftAgentIds)
	) {
		return false;
	}
	if (areAgentIdListsEqual(selectedAgentIds, draftAgentIds)) {
		return false;
	}
	if (draftAgentIds.length === 0 && selectedAgentIds.length > 0) {
		return false;
	}
	return true;
};

type ShouldRemoveMentionDestroyedAgentArgs = {
	state: SelectedAgentTransitionState;
	agentId: string;
};

const shouldRemoveMentionDestroyedAgent = ({
	state,
	agentId,
}: ShouldRemoveMentionDestroyedAgentArgs): boolean => {
	if (state.isSubmitClearing) {
		return false;
	}
	if (state.isReasoningModeMenuOpen && isDefaultRovoChat({ agentId })) {
		return false;
	}
	return true;
};

type SelectedAgentTransition = {
	shouldHydrateDraftMentionIds: (args: ShouldHydrateDraftMentionIdsArgs) => boolean;
	shouldRemoveMentionDestroyedAgent: (args: ShouldRemoveMentionDestroyedAgentArgs) => boolean;
};

/** Pure decision predicates over the transition state, safe to call from anywhere. */
export const selectedAgentTransition: SelectedAgentTransition = {
	shouldHydrateDraftMentionIds,
	shouldRemoveMentionDestroyedAgent,
};
